import React from "react";
import { ArrowRightCircle } from "lucide-react";
import ImageGalleryCard from "./ui/ImageGalleryCard";
import { Link } from "react-router-dom";

const venueList = [
  { id: 1, name: "Osaka Castle (Osaka-jō)" },
  { id: 2, name: "Universal Studios Japan (USJ)" },
  { id: 3, name: "Dotonbori" },
  { id: 4, name: "Shitennoji Temple" },
  { id: 5, name: "Osaka Aquarium Kaiyukan" },
  { id: 6, name: "Umeda Sky Building" },

];

const Venue = () => {
  return (
    <div className="w-full py-8 px-4 md:px-12 flex flex-col justify-center items-center md:px-32 border-t">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
        QUANTUMTECH – Venue
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full max-w-6xl items-center">
        {/* Description Section */}
        <div className="w-full flex flex-col items-center md:items-start text-center md:text-left">
          <h2 className="text-lg text-gray-600 font-medium mb-2">Proposed Conference Venue</h2>
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-one">
            Osaka | Japan
          </h1>
          <ul className="space-y-4">
            {venueList.map((item) => (
              <li
                key={item.id}
                className="flex items-center gap-3 text-lg text-gray-700"
              >
                <ArrowRightCircle size={20} className="text-one shrink-0" />
                {item.name}
              </li>
            ))}
          </ul>
        </div>

        {/* Image Gallery Section */}
        <div className="w-full flex justify-center">
          <ImageGalleryCard />
        </div>
      </div>

      {/* CTA Button */}
      <Link to="/venue">
        <button className="bg-accent text-white px-10 md:px-20 py-2 rounded-full mt-6 text-sm md:text-base hover:bg-one transition">
          View All
        </button>
      </Link>
    </div>
  );
};

export default Venue;